import { render, staticRenderFns } from "./BoxesCardView.vue?vue&type=template&id=5c2673da&scoped=true&"
import script from "./BoxesCardView.vue?vue&type=script&lang=js&"
export * from "./BoxesCardView.vue?vue&type=script&lang=js&"
import style0 from "./BoxesCardView.vue?vue&type=style&index=0&id=5c2673da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2673da",
  null
  
)

export default component.exports